import { t } from "i18next";
import type { CountryCode } from "libphonenumber-js";
import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

export const addressSchema = z.object({
  // `googlePlaceId` and `name` are set only by picking a suggestion.
  googlePlaceId: z.string().min(1, { message: t("validation.selectAddress") }),
  addressLine1: z.string().min(1, { message: t("validation.required") }),
  name: z.string().min(1, { message: t("validation.selectAddress") }),
  addressLine2: z.string(),
  city: z.string().min(1, { message: t("validation.required") }),
  state: z.string().min(1, { message: t("validation.required") }),
  country: z.string().min(1, { message: t("validation.required") }),
  zipCode: z.string().min(1, { message: t("validation.required") }),
  latitude: z.number(),
  longitude: z.number(),
});

export const phoneSchema = z
  .string()
  .min(1, { message: t("validation.required") })
  .refine(
    (value) => {
      const formatRegex = /^[A-Z]{2}-\d+-\d+$/;
      if (!formatRegex.test(value)) {
        return false;
      }

      const parts = value.split("-");
      if (parts.length !== 3) return false;

      const [countryCode, callNumber, phoneNumber] = parts;

      const fullPhoneNumber = `+${callNumber}${phoneNumber}`;

      return isValidPhoneNumber(fullPhoneNumber, countryCode as CountryCode);
    },
    {
      message: t("validation.phone_invalid"),
    },
  );
